import React from 'react';
import List from '../list';
import Text from '../text';
import spacing from '../themes/spacing';
import {
  StyledUnderline,
  FullWidthWrapper,
  FullWidthTextWrapper,
} from './styles';

interface FilterList {
  value: string;
  title: string;
}

interface FilterBarProps {
  filterList: FilterList[];
  onSelect: (filterItem) => void;
  selected: string;
  withUnderline?: boolean;
  listSpacing: keyof typeof spacing;
  isFullWidth?: boolean;
}

const FilterBar = (props: FilterBarProps) => {
  const {
    filterList = [],
    onSelect = () => {},
    selected = null,
    withUnderline = false,
    listSpacing = 'xl',
    isFullWidth = false,
  } = props;

  const tabList = filterList.map(filterItem => {
    const isSelected = filterItem.value === selected;

    const FilterText = (
      <Text
        key={filterItem.title}
        intent={isSelected ? 'primary' : 'secondary'}
        onClick={() => {
          onSelect(filterItem);
        }}
        variant="titlemd"
        style={{ cursor: 'pointer' }}
        data-testid={`${filterItem.value}-filter-button`}
      >
        {filterItem.title}
      </Text>
    );

    if (isFullWidth) {
      return (
        <FullWidthTextWrapper
          onClick={() => {
            onSelect(filterItem);
          }}
          isSelected={isSelected}
        >
          {FilterText}
        </FullWidthTextWrapper>
      );
    }

    if (withUnderline) {
      return (
        <StyledUnderline key={filterItem.title} isSelected={isSelected}>
          {FilterText}
        </StyledUnderline>
      );
    }
    return FilterText;
  });

  if (isFullWidth) {
    return <FullWidthWrapper>{tabList}</FullWidthWrapper>;
  }

  return (
    <List
      alignment="horizontal"
      listSpacing={listSpacing}
      listWrapSpacing="none"
      dataSource={tabList}
      overflow
    />
  );
};

export default FilterBar;
